import { type JSX, useState } from 'react';

import { tGlobal } from '../services/translation';
import { PlayCircleIcon } from './icons/play-circle-icon';
import { ModalYoutubeEmbed } from './modal-youtube-embed';

type ButtonSeeHowItWorksProps = {
  videoUrl: string;
};

export function ButtonSeeHowItWorks(props: ButtonSeeHowItWorksProps): JSX.Element {
  const { videoUrl } = props;
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="font-body-3-m mt-1 flex items-center gap-1 text-branding-accent"
        onClick={function () {
          setIsVideoOpen(true);
        }}
      >
        <PlayCircleIcon />
        {tGlobal('seeHowItWorks')}
      </button>
      <ModalYoutubeEmbed
        isOpen={isVideoOpen}
        onClose={function () {
          setIsVideoOpen(false);
        }}
        videoUrl={videoUrl}
      />
    </>
  );
}
